import { create } from 'zustand';

export const useAssignmentTemplateStore = create((set) => ({
    items: [],
    loading: false,
    detailLoading: false,
    error: null,
    columnFilters: {},
    uniqueValues: {},

    paginationData: {
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        itemsPerPage: 20,
        hasNextPage: false,
        hasPreviousPage: false,
    },

    searchParams: {
        page: 1,
        pageSize: 20,
        sortBy: 'name',
        sortOrder: 'asc',
        search: '',
    },

    isFormOpen: false,
    isEditMode: false,
    selectedFlow: null,
    deleteDialogOpen: false,
    flowToDelete: null,

    setItems: (items) => set({ items }),
    setLoading: (loading) => set({ loading }),
    setDetailLoading: (detailLoading) => set({ detailLoading }),
    setError: (error) => set({ error }),
    setColumnFilters: (columnFilters) => set({ columnFilters }),
    setUniqueValues: (uniqueValues) => set({ uniqueValues: uniqueValues || {} }),
    clearError: () => set({ error: null }),
    setPaginationData: (paginationData) => set({ paginationData }),
    setSearchParams: (params) => set((state) => ({ searchParams: { ...state.searchParams, ...params } })),

    openAddForm: () => set({ isFormOpen: true, isEditMode: false, selectedFlow: null, error: null }),
    openEditForm: (flow) => set({ isFormOpen: true, isEditMode: true, selectedFlow: flow, error: null }),
    closeForm: () => set({ isFormOpen: false, selectedFlow: null, error: null }),

    openDeleteDialog: (flow) => set({ deleteDialogOpen: true, flowToDelete: flow }),
    closeDeleteDialog: () => set({ deleteDialogOpen: false, flowToDelete: null }),
}));
